<template>
  <!-- Artículo del blog en las plantillas 2 a 5. Los datos los calcula la página (pages/blog/[id].vue) -->
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="articulo.Titulo" :subtitulo="articulo.Subtitulo" :imagen="articulo.Imagen || P.Imagen" :filtro="articulo.Imagen ? '' : P.ImagenFiltro"
      :rastro="[{ texto: tituloSeccion(NOTARIA, 'Blog', $t), to: getLocalePath('/blog') }, { texto: articulo.Titulo }]">
      <p class="n2-cabeza-pagina__meta">
        <span v-if="fecha"><v-icon size="16">mdi-calendar-blank-outline</v-icon> {{ fecha }}</span>
        <span v-if="articulo.Contenido"><v-icon size="16">mdi-clock-outline</v-icon> {{ tSolicitud('{n} min de lectura', { n: minutosLectura(articulo.Contenido) }) }}</span>
        <span v-if="articulo.Autor"><v-icon size="16">mdi-account-outline</v-icon> {{ articulo.Autor }}</span>
      </p>
      <div v-if="articulo.Categorias?.length" class="n2-etiquetas">
        <span v-for="c in articulo.Categorias" :key="c">{{ c }}</span>
      </div>
    </N2CabezaPagina>

    <section class="n2-seccion n2-seccion--pagina">
      <div class="n2-contenedor n2-contenedor--lectura">
        <div class="n2-texto-largo n2-texto-largo--articulo" v-thtml="articulo.Contenido"></div>

        <!-- Encargo online del trámite del que habla el artículo -->
        <SolicitudBlogLlamada :tramite="articulo.TramiteSolicitud" />

        <div v-if="articulo.MostrarCompartir !== false" class="n2-compartir">
          <span class="n2-compartir__titulo">{{ $t('compartir') }}</span>
          <a :href="`https://api.whatsapp.com/send?text=${encodeURIComponent(articulo.Titulo + ' ' + url)}`" target="_blank" rel="noopener" aria-label="WhatsApp"><v-icon size="20">mdi-whatsapp</v-icon></a>
          <a :href="`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(articulo.Titulo)}`" target="_blank" rel="noopener" aria-label="X"><span class="n2-compartir__x">𝕏</span></a>
          <a :href="`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`" target="_blank" rel="noopener" aria-label="LinkedIn"><v-icon size="20">mdi-linkedin</v-icon></a>
          <button type="button" :aria-label="tSolicitud('Copiar enlace')" @click="copiar"><v-icon size="20">{{ copiado ? 'mdi-check' : 'mdi-link-variant' }}</v-icon></button>
          <span v-if="copiado" class="n2-compartir__aviso" role="status">{{ tSolicitud('Enlace copiado') }}</span>
        </div>

        <NuxtLink :to="getLocalePath('/blog')" class="n2-enlace"><span aria-hidden="true">←</span> {{ $t('volver') }}</NuxtLink>
      </div>
    </section>

    <section v-if="relacionados.length" class="n2-seccion n2-seccion--suave">
      <div class="n2-contenedor">
        <h2 class="n2-titulo-seccion n2-titulo-seccion--pequeno n2-aparece">{{ tSolicitud('También le puede interesar') }}</h2>
        <N2ListaArticulos :articulos="relacionados" :columnas="3" nivel="h3" />
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, minutosLectura, useAparicion } from '../../composables/useNotaria2'
import N2CabezaPagina from './N2CabezaPagina.vue'
import N2ListaArticulos from './N2ListaArticulos.vue'

defineProps({
  articulo: { type: Object, required: true },
  fecha: { type: String, default: '' },
  relacionados: { type: Array, default: () => [] },
})

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { $t, getLocalePath } = useUtils()
const raiz = ref(null)
useAparicion(raiz)

const P = computed(() => NOTARIA.value?.Theme?.Blog ?? {})
const url = ref('')
onMounted(() => { url.value = window.location.href })

const copiado = ref(false)
function copiar() {
  navigator.clipboard?.writeText(url.value).then(() => {
    copiado.value = true
    setTimeout(() => { copiado.value = false }, 2500)
  })
}
</script>
